import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Spin, Button, Icon, Layout, message } from 'antd';
import {
	Cotainer,
	InfoSection,
	MainSection
} from '../../components/AppWrapper';
import SideBar from '../../components/SideBar';
import {
	GOING_PUBLIC_COLLATERAL_GLOBE,
	GOING_PUBLIC_COLLATERAL_GLOBE_GREEN,
	ICON_ADMIN
} from '../../config/media';
import Wrapper from './style';
import { getCollateral, getPublicExchange, putExchange } from '../../common/fetch';
import FeaturedProject from './FeaturedProject';
import OtherProjects from './OtherProjects';
import CollateralModal from '../ExchangeCollateral/CollateralModal';
import { pickRandomImage } from '../Project/Project';
import ExchangeTerminateMessage from '../../common/exchangeTerminate'

const { Content } = Layout;

class ProjectList extends Component {
	state = {
		isLoaded: false,
		mobileToggle: false,
		featured: {},
		others: [],
		isVisible: false,
		CollateralStep: 1
	};

	bannerBox = null;

	componentDidMount() {
		const { exchange } = this.props;
		this.getData();
		this.getCollateralData(exchange && exchange[0] && exchange[0].id);
	}

	getCollateralData = async (id) => {
		try {
			const res = await getCollateral(id);
			const { data } = res;
			this.props.actions.setCollateral(data);
			this.setState({ isLoading: false });
		} catch (error) {
			console.error(error);
		}
	}

	goToCollateral = () => {
		const { exchange, history } = this.props;
		if (exchange.length === 0) {
			history.push('/');
		} else {
			history.push('/collateral');
		}
	};

	getData = async () => {
		try {
			const res = await getPublicExchange();

			this.setState({
				isLoaded: true,
				featured: res.data.length >= 1 ? res.data[0] : {},
				others: res.data
			});
		} catch (error) {
			console.error(error);
		}
	};

	setRef = (el) => {
		this.bannerBox = el;
	};

	renderContent = () => {
		const { stat, location } = this.props;
		const { featured, others } = this.state;
		const urlSearchParams = new URLSearchParams(location.search);
		const params = Object.fromEntries(urlSearchParams.entries());

		const exchange = featured ? featured : {};
		if (params && params.type && params.type === "featured") {
			return (
				<Wrapper>
					<FeaturedProject collateral={exchange} stat={stat} randomImage={pickRandomImage(exchange.id)} />
				</Wrapper>
			);
		} else {
			return (
				<Wrapper>
					<FeaturedProject collateral={exchange} stat={stat} randomImage={pickRandomImage(exchange.id)} />
					<OtherProjects data={others} stat={stat} />
				</Wrapper>
			);
		}
	};

	handleShowModal = () => {
		this.setState({ isVisible: true })
	}

	handleCancelModal = () => {
		this.setState({ isVisible: false, CollateralStep: 1 })
	}

	handleStep = (CollateralStep) => {
		this.setState({ CollateralStep })
	}

	onPubilc = () => {
		const { is_public } = this.props.collateral;
		if (is_public) {
			message.info('This exchange is already public.');
			this.handleCancelModal();
			return;
		}
		this.setPublic();
	};

	setPublic = async () => {
		const { collateral, exchange } = this.props;
		const body = {
			id: collateral.id,
			is_public: true,
			info: {
				public: {
					title: collateral ? collateral.name : '',
					country: collateral && collateral.info ? collateral.info.biz.DEFAULT_COUNTRY : '',
					url: collateral && collateral.info ? collateral.info.tech.EXCHANGE_CLIENT_URL : ''
				}
			}
		};
		try {
			await putExchange(body);
			this.props.actions.updateCollateral({ is_public: true });
			const newData = exchange.map((item) => {
				if (item.id === collateral.id) {
					const obj = { ...item };
					obj.is_public = true;
					return obj;
				}
				return item;
			});
			this.props.exchangeActions.readData(newData);
			this.handleCancelModal();
			message.success('Success to set Public');
			this.props.history.push(`/project/${collateral.id}`)
		} catch (error) {
			console.error(error);
			message.error('Failed to set Public');
		}
	};

	goToPublic = () => {
		this.props.history.push(`/project/${this.props.collateral.id}`);
	};

	render() {
		const { isLoaded, mobileToggle, isVisible, CollateralStep } = this.state;
		const { exchange } = this.props;
		const btnStyle = {
			width: '156px'
		};
		const exchangeData = exchange[0];

		// const OptionImgProps = {
		// 	height: '15px',
		// 	verticalAlign: 'middle',
		// 	marginRight: '8px'
		// };

		return (
			<Cotainer>
				<Layout>
					<SideBar>
						<InfoSection className={`${mobileToggle ? 'less-content on' : 'less-content'} ${this.props.constant.isExchangeExpired ? "expired-status" : ""}`}>
							<div>
								<h3>Explore and contribute to projects</h3>
								<p>
									See what others are creating with the exchange kit. Contribute collateral by staking XHT and help spread crypto adoption.
								</p>
								<Link to="/project">
									<Button
										style={btnStyle}
										block
										type="primary"
										onClick={() => {
											if (window.innerWidth < 1200) {
												this.setState({ mobileToggle: false });
											}
										}}
									>
										<img
											src={ICON_ADMIN}
											alt="summary"
											style={{ color: '#42454D' }}
										/>
										Summary
									</Button>
								</Link>
								<Link to="/project?type=featured">
									<Button
										style={btnStyle}
										block
										type="primary"
										onClick={() => {
											if (window.innerWidth < 1200) {
												this.setState({ mobileToggle: false });
											}
											// message.info('Coming Soon!');
										}}
									>
										<Icon
											type="star"
											style={{ fontSize: '15px', color: '#ffffff' }}
										/>
										Featured Projects
									</Button>
								</Link>
								<div className='divider-line'></div>
								<div className='public-info'>Go public and share a link to your own project.</div>
								<div className="flex-center">
									<div>
										{exchangeData && exchangeData.is_public
											?
											<img src={GOING_PUBLIC_COLLATERAL_GLOBE_GREEN} className="user-xht" alt="user-profile-xht" />
											:
											<img src={GOING_PUBLIC_COLLATERAL_GLOBE} className="user-xht" alt="user-profile-xht" />
										}
									</div>
									<div>
										<div>
											<span className="title">Visibility:</span>{' '}
											<span
												className={exchangeData && exchangeData.is_public ? "public" : ""}
											>
												{exchangeData && exchangeData.is_public ? 'Public' : 'Private'}
											</span>
										</div>
										{exchangeData && exchangeData.is_public
											?
											<span
												className="configure-link"
												onClick={this.goToPublic}
											>
												Visit public page
											</span>
											: <span className="configure-link" onClick={this.handleShowModal}>Configure</span>
										}
									</div>
								</div>
							</div>
							<CollateralModal
								isVisible={isVisible}
								exchangeData={exchangeData}
								step={CollateralStep}
								handleStep={this.handleStep}
								onOk={this.onPubilc}
								handleClose={this.handleCancelModal}
							/>
						</InfoSection>
					</SideBar>
					<Content>
						<MainSection>
							{isLoaded ? (
								<Wrapper >
									<div className={this.props.constant.isExchangeExpired ? "expired-status" : ""}>
										{this.renderContent()}
									</div>
									{this.props.constant.isExchangeExpired && <ExchangeTerminateMessage />}
								</Wrapper>
							) : (
								<Spin size="large" />
							)}
						</MainSection>
					</Content>
				</Layout>
			</Cotainer >
		);
	}
}

const mapStateToProps = (state) => ({
	constant: state.constant,
});

export default connect(mapStateToProps)(ProjectList);
